import { render, staticRenderFns } from "./ViewBuyRequest.vue?vue&type=template&id=0313d44c&"
import script from "./ViewBuyRequest.vue?vue&type=script&lang=js&"
export * from "./ViewBuyRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports